/**
 * Returns the string with the first letter capitalized
 *
 * @param {string} str
 *
 * @returns {string}
 */
export const capitalize = ([firstLetter, ...rest]: string) => {
  return [firstLetter.toUpperCase(), ...rest].join("");
};

/**
 * Returns the base64 string for the provided string
 *
 * @param {string} data
 *
 * @returns {string}
 */
export const base64Encode = (data: string) => {
  return btoa(data);
};

/**
 * Returns the decoded string for the provided encode string
 *
 * @param {string} data
 *
 * @returns {string} Decoded string
 */
export const base64Decode = (data: string) => {
  return atob(data);
};

export const stripEmojis = (text: string) => {
  // Strip emojis from the displayed text to prevent the emoji plugin from converting them to emoji entities
  // The full name with emojis is preserved in the mention entity data
  return (text || "")
    .replace(
      /[\u{1F300}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F900}-\u{1F9FF}\u{1F1E0}-\u{1F1FF}]/gu,
      ""
    )
    .trim();
};
